<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Historique du patient</div>
        <div class="modal-body">
            <div class="journal-wrapper" *ngIf="_patientJournal">
                <h1>Informations patient</h1>
                <div *ngIf="_patientPoids && _patientPoids !== ''">{{ _patientPoids }}</div>
                <div *ngIf="_patientTaille && _patientTaille !== ''">{{ _patientTaille }}</div>
                <div *ngIf="_patientCreatine && _patientCreatine !== ''">{{ _patientCreatine }}</div>
                <div *ngIf="_patientDFG && _patientDFG !== ''">{{ _patientDFG }}</div>
                <div *ngIf="_patientInsHep && _patientInsHep !== ''">{{ _patientInsHep }}</div>
                <div *ngIf="_patientGrossesse && _patientGrossesse !== ''">{{ _patientGrossesse }}</div>
                <div *ngIf="_patientAllaitement && _patientAllaitement !== ''">{{ _patientAllaitement }}</div>
                <div *ngIf="_patientAmenorrhee && _patientAmenorrhee !== ''">{{ _patientAmenorrhee }}</div>
            </div>

            <div class="historique-wrapper" *ngIf="dataSource && dataSource.data && dataSource.data.length > 0">
                <h1>Historique identité</h1>
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                      <!-- use a disabled button to provide padding for tree leaf -->
                      <button mat-icon-button disabled></button>
                      <span class="node-value">
                        <span class="node-value-name">{{node.name}}</span> : {{node.value}}
                      </span>
                    </mat-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                      <button mat-icon-button matTreeNodeToggle
                              [attr.aria-label]="'Toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                      </button>
                      <span class="node-title" matTreeNodeToggle>
                        {{node.name}}
                      </span>
                    </mat-tree-node>
                </mat-tree>
            </div>
            <div class="button-wrapper">
              <frg-button [type]="'reset'" (activated)="closeModal(true)"
                  [backgroundColor]="'var(--darkest-primary)'">Fermer
              </frg-button>
          </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>